import { useState } from "react";
import styled, { keyframes } from "styled-components";
import Auth from "src/Auth";
import Utils from "src/Utils";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-top: 2px solid #333;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const Container = styled.div`
  padding: 20px;
  h1 {
    margin-bottom: 0px !important;
  }
  h2 {
    margin-bottom: 0px !important;
  }
  textarea {
    width: 100%;
    height: 100px;
    margin-bottom: 20px;
  }
`;

const StreamHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;

  button {
    margin: 0 !important;
    padding: 5px !important;
    border-radius: 5px !important;
    border: 1px solid #ccc !important;
    cursor: pointer !important;

    &:disabled {
      background-color: #ccc !important;
      color: #fff !important;
      cursor: not-allowed !important;
    }
  }
`;
const RawLogContainer = styled.div`
  padding: 10px;
  border: 1px solid #666;
  border-radius: 5px;
  white-space: pre-wrap;
  word-wrap: break-word;
  height: 500px;
  overflow-y: auto;
`;
function StreamReplayPage() {
  const [chunkLog, setChunkLog] = useState("");
  const [stream, setStream] = useState("");
  const [isStreaming, setIsStreaming] = useState(false);
  const [mode, setMode] = useState("");
  const [error, setError] = useState(null);
  const [index, setIndex] = useState(0);
  const [total, setTotal] = useState(0);
  const handleStream = async () => {
    setStream("");
    setIsStreaming(true);
    await Auth.streamWithIdToken(
      `/api/admin/streamTools/replay-stream`,
      {
        method: "POST",
        chunkLog,
      },
      null,
      (chunk) => {
        if (chunk.mode) {
          setMode(chunk.mode);
        }
        if (chunk.mode === "writing") {
          setStream((prev) => prev + chunk.text);
        }
        if (chunk.totalChunks) {
          setTotal(chunk.totalChunks);
        }
        if (chunk.chunkIndex) {
          setIndex(chunk.chunkIndex);
        }
      },
      () => {
        setIsStreaming(false);
        setMode("completed");
      },
      (error) => {
        setIsStreaming(false);
        setError(error);
        setMode("error");
      }
    );
  };

  const handleParseChunkLog = async () => {
    const response = await Auth.fetchWithIdToken(`/api/admin/streamTools/parse-chunk-log`, {
      chunkLog,
    });

    const { parsedText, fullText } = response;
    const fullStreamValue = `parsedText: \n\n${parsedText}\n\nfullText: \n\n${fullText}`;
    setStream(fullStreamValue);
  };

  const reset = () => {
    setStream("");
    setMode("");
    setError(null);
    setIndex(0);
    setTotal(0);
  };

  return (
    <Container>
      <h1>Stream Replay</h1>
      <p>Replay an arbitrary stream by providing a chunk log.</p>
      <h2>Chunk Log</h2>
      <textarea
        value={chunkLog}
        onChange={(e) => setChunkLog(e.target.value)}
      />
      <StreamHeader>
        <h2>Stream</h2>
        {chunkLog && <button onClick={handleParseChunkLog}>Parse Only</button>}
        {chunkLog && (
          <button
            onClick={handleStream}
            disabled={isStreaming}
          >
            Run
          </button>
        )}
        {stream && (
          <button
            onClick={reset}
            disabled={isStreaming}
          >
            Reset
          </button>
        )}
        {isStreaming && <Spinner />}
        {mode && <span>Mode: {mode}</span>}
        {isStreaming && <span>{`| completed ${index} / ${total}`}</span>}
      </StreamHeader>
      {error && (
        <p>
          Error: <pre>{JSON.stringify(error, null, 2)}</pre>
        </p>
      )}
      {stream && <RawLogContainer>{Utils.nl2br(stream)}</RawLogContainer>}
    </Container>
  );
}

export default StreamReplayPage;
